import React from 'react';

interface ImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  rounded?: boolean;
  shadow?: boolean;
}

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  className = '',
  rounded = false,
  shadow = false,
}) => {
  const baseClasses = `w-full ${rounded ? 'rounded-lg' : ''} ${shadow ? 'shadow-lg' : ''}`;
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={`${baseClasses} ${className}`}
    />
  );
};

export default Image;
